/* EVASIMIN Custom JS */

/* EVASIMIN collection grid density toggle (2/3/4 columns, desktop).
   Broadcast's collection.liquid sets --COLUMNS as an inline CSS custom
   property on the #Collection--{{ section.id }} element; overriding it
   client-side re-flows the grid without a page reload. Choice is kept in
   sessionStorage so it survives navigating between collection pages
   within the same visit, resetting on a fresh session. */
(function () {
  var STORAGE_KEY = 'evs-grid-density';

  function applyDensity(root, cols) {
    var section = root.closest('[data-section-type="collection"]');
    if (!section) return;
    section.style.setProperty('--COLUMNS', cols);

    var buttons = root.querySelectorAll('.evs-density__btn');
    for (var i = 0; i < buttons.length; i++) {
      var isActive = buttons[i].getAttribute('data-evs-cols') === String(cols);
      buttons[i].classList.toggle('is-active', isActive);
    }
  }

  function initDensityToggle(root) {
    if (root.dataset.evsDensityInit) return;
    root.dataset.evsDensityInit = 'true';

    var stored = null;
    try {
      stored = sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {}

    if (stored) applyDensity(root, stored);

    root.addEventListener('click', function (event) {
      var btn = event.target.closest('.evs-density__btn');
      if (!btn || !root.contains(btn)) return;
      var cols = btn.getAttribute('data-evs-cols');
      applyDensity(root, cols);
      try {
        sessionStorage.setItem(STORAGE_KEY, cols);
      } catch (e) {}
    });
  }

  function init() {
    var toggles = document.querySelectorAll('[data-evs-density]');
    for (var i = 0; i < toggles.length; i++) initDensityToggle(toggles[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
